module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/thumbtack-6f53b383a095953f9acaf012be2066bb.svg";